import { isEqual, partition, uniq } from 'lodash';
import { useAirportsWidgetConfig } from '../../../../../components/SearchForm/components/AirportsWidget/hooks/useAirportsWidgetConfig.js';
import { useAirportsWidgetState } from '../../../../../components/SearchForm/components/AirportsWidget/hooks/useAirportsWidgetState.js';
export const useGetNextValue = (airports, currentValue) => {
  const {
    retrieveCodes
  } = useAirportsWidgetConfig({
    airports
  });
  const {
    isChecked
  } = useAirportsWidgetState({
    value: currentValue,
    airports
  });
  return joinedCodes => {
    const codes = joinedCodes.split(',');
    const allAirportsCodes = codes.flatMap(item => retrieveCodes(item) ?? []);
    if (allAirportsCodes.length > 0) {
      if (isChecked(joinedCodes)) {
        return currentValue.filter(activeCode => !allAirportsCodes.includes(activeCode));
      }
      return uniq([...currentValue, ...allAirportsCodes]);
    }
    const [checkedCodes, notCheckedCodes] = partition(codes, isChecked);
    const updatedCodes = codes.length > 1 && !isEqual(checkedCodes, codes) ? codes : notCheckedCodes;
    const notActiveValues = currentValue.filter(item => !checkedCodes.includes(item));
    return [...notActiveValues, ...updatedCodes];
  };
};